/**
 * Mock 模块：heart_voyage_invite_list
 * 默认 6 条对齐 state-default；搜索 1 条对齐 state-search；空数组对齐 state-empty。
 * @see mockMd/heart_voyage_invite_list.md
 */
import {storiesAvatar} from '../components/BindRelationDrawer/stories-images'
import {InviteStatus} from '../types'
import type {
  ActivityMemberV2,
  HeartVoyageInviteUserItem,
  InviteListData,
} from '../types'

export const MOCK_USER_AVATAR = storiesAvatar

const mockMember = (id: number): ActivityMemberV2 => ({
  id,
  name: 'user name…',
  zy_id: '102938475',
  avatar: MOCK_USER_AVATAR,
  gender: 1,
})

const mockInviteItem = (
  id: number,
  invite_status: InviteStatus
): HeartVoyageInviteUserItem => ({
  member: mockMember(id),
  intimacy: 22500,
  show_intimacy: true,
  invite_status,
  from_hot_room: false,
})

/** @see mockMd/heart_voyage_invite_list.md */
export const HeartVoyageInviteListMock: InviteListData = {
  err_msg: '',
  list: [
    mockInviteItem(10002, InviteStatus.Inviting),
    mockInviteItem(10003, InviteStatus.Invitable),
    mockInviteItem(10004, InviteStatus.Invitable),
    mockInviteItem(10005, InviteStatus.Invitable),
    mockInviteItem(10006, InviteStatus.Uninvitable),
    mockInviteItem(10007, InviteStatus.Uninvitable),
  ],
}

/** 搜索有结果：稿面 1 行 */
export const HeartVoyageInviteListSearchMock: InviteListData = {
  err_msg: '',
  list: [mockInviteItem(123, InviteStatus.Invitable)],
}

/** 搜索无结果 */
export const HeartVoyageInviteListEmptyMock: InviteListData = {
  err_msg: '',
  list: [],
}
